document.addEventListener('click', function (event) {
  const trackedElement = event.target.closest('[data-event]');

  if (!trackedElement) return;

  const eventName = trackedElement.dataset.event;

  const eventData = {
    link_text: trackedElement.innerText.trim(),
    link_url: trackedElement.href || '',
    page_path: window.location.pathname
  };

  // Send directly to Google Analytics (GA4)
  if (typeof gtag === 'function') {
    gtag('event', eventName, eventData);
  }

  // Also publish to Shopify for any future pixels
  if (
    window.Shopify &&
    Shopify.analytics &&
    typeof Shopify.analytics.publish === 'function'
  ) {
    Shopify.analytics.publish(eventName, eventData);
  }
});